import React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import is from 'styled-is';
import HBText from '@honeybook/hbui/dist/components/HBText/HBText';
import HBSwitch from '@honeybook/hbui/dist/components/HBSwitch/HBSwitch';
import spacing from '@honeybook/hbui/dist/styles/spacing';
import { EDIT_AUTOMATION_TOOLTIP } from '../StepSideBar/StepSideBar.styles';
import { AnalyticsEvents } from '../../../../../services/analytics/analytics-events';
import useAnalytics from '../../../../../common/useAnalytics';
import { useRootStore } from '~/stores/useRootStore';

const ApprovalSwitcher = ({ isPipelineStage = false }) => {
    const {
        automationUiStore: {
            isApplied,
            isSelectedStepEditingDisabled,
            tooltipCommonProps,
            selectedStep: {
                combinedType,
                isApprovalRequired,
                isDone,
                toggleApprovalMethod
            }
        }
    } = useRootStore();

    const { track } = useAnalytics();

    const _toggleApprovalMethod = () => {
        if (!isSelectedStepEditingDisabled) {
            toggleApprovalMethod();
            track(AnalyticsEvents.AutomationsSideBarToggleApproval, {
                action: 'click',
                type: combinedType,
                toggled_to: !isApprovalRequired ? 'on' : 'off'
            });
        }
    };

    const tooltipText = isApplied
        ? EDIT_AUTOMATION_TOOLTIP
        : `HoneyBook will notify you when this action is 
       waiting for your approval. A task will 
       automatically be created inside the project 
       and once you mark the task as done, the 
       action will be performed`;

    return (
        <SwitcherContainer isDisabled={isSelectedStepEditingDisabled}>
            <SwitcherText
                onClick={_toggleApprovalMethod}
                type="Body6DarkPrimary"
            >
                {`Require approval before ${
                    isPipelineStage ? 'moving' : 'sending'
                }`}
            </SwitcherText>
            <HBSwitch
                id="automations-approval-switch"
                checked={isApprovalRequired}
                onChange={_toggleApprovalMethod}
                disabled={isDone || isSelectedStepEditingDisabled}
                disabledTooltipText={tooltipText}
                disabledTooltipProps={{
                    ...tooltipCommonProps,
                    maxWidth: isSelectedStepEditingDisabled
                        ? tooltipCommonProps.maxWidth
                        : '360px'
                }}
                label="Require approval"
            />
        </SwitcherContainer>
    );
};

const SwitcherText = styled(HBText)`
    flex-grow: 1;
    cursor: pointer;
`;

const SwitcherContainer = styled.div<{
    isDisabled: boolean;
}>`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: ${spacing[12]} 0;
    ${is('isDisabled')`
        ${SwitcherText} {
            cursor: default;
        }
    `}
`;

export default observer(ApprovalSwitcher);
